import { createContext } from "react"
import type { UiConfig } from "@/types"

// Fail-closed defaults: every flag off until the server (GET /config/ui) says
// otherwise, so a slow or failed fetch hides in-progress features rather than
// flashing them on. Mirrors the dash's FeatureFlags pattern.
export const DEFAULT_FEATURE_FLAGS: UiConfig = {
  suggested_chips_enabled: false,
  careadvocate_callback_scheduling_enabled: false,
}

export const FeatureFlagsContext = createContext<UiConfig>(
  DEFAULT_FEATURE_FLAGS,
)
